<template>
  <react-wrapper :component="unsupportedBrowser" :style="{ height: '100%' }" />
</template>

<script lang="ts">
import UnsupportedBrowser from '@/react-components/pages/unsupported-browser'

export default {
  computed: {
    unsupportedBrowser() {
      return UnsupportedBrowser
    },
  },
}
</script>
